import { Box, Flex } from '@chakra-ui/react'

export function HeaderCard({ icon, title, ...rest }) {
  return (
    <Flex
      alignItems="center"
      justifyContent="flex-start"
      px={4}
      py={1}
      border="1px solid #C7C7C7"
      bgColor="white"
      {...rest}
    >
      {icon}
      <Box ml={2} fontSize="21px" fontWeight="semibold">
        {title}
      </Box>
    </Flex>
  )
}
